"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalViewerPermissions = void 0;
var enum_1 = require("../enum");
exports.internalViewerPermissions = [
    enum_1.Permissions.CanIgnoreCustomGrants,
    enum_1.Permissions.CanManageAllAccounts,
];
